<template>
  <v-dialog persistent :value="addModal" width="500">
    <v-card>
      <popup-heading 
      title="CREATE A BUSINESS" 
      subtitle="Create a new Business.">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
          <v-btn
            depressed
            @click="addItem()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>
      <v-layout  justify-center>
        <v-flex class="sm12 md8 lg8 text-center">
          <v-card-text class="pb-5">
            <v-form ref="addForm" lazy-validation>
              <v-flex xs12 class="mb-4 pt-4">
                  <p class="mb-0 font-weight-bold headline">Name:</p>
                  <v-text-field
                    class="pt-0 input-text-center"
                    v-model="form.name"
                    :rules="fieldRequired"
                  ></v-text-field>
                </v-flex>
              </v-form>
            </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      form: {
        name: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      addModal: 'business/add',
    }),
  },
  mounted() {
    this.closeModal();
  },
  methods: {
    /**
     * Get business list
     */
    fetchBusinesses() {
      const url = `${Env.url}/api/v1/businesses`;
      AuthApi.getApi(url, {})
        .then((res) => {
         this.setList(res.data.payload);
        })
        .catch(() => {
          console.log('Unable to fetch business.')
        });
    },

    /**
     * Add new business
     */
    addItem() {
      if (this.$refs.addForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/businesses`;
        AuthApi.postApi(url, this.form)
          .then((res) => {
            this.spinner(false);
            this.fetchBusinesses();
            this.closeModal();
            this.snackbar({
              text: res.data.msg,
              timeout: 4000,
              open: true,
            });
          })
          .catch((err) => {
             this.snackbar({
              text: err.response.data.msg ? err.response.data.msg : 'Please try again later.',
              timeout: 4000,
              open: true,
            });
            this.spinner(false);
          });
      }
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.form = Helper.setObjValueEmpty(this.form);
      this.setAdd(false);
    },

    ...mapActions({
      setAdd: 'business/setAdd',
      setList: 'business/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
